



























































































































































































import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import { PendingContribution } from "@/employer/types";
import moment from "moment";
import _ from "lodash";
import { Location } from "vue-router";
import ActionMenu from "@/shared/components/ui/ActionMenu.vue";
import Button from "@/shared/components/ui/Button.vue";
import Pagination from "@/shared/components/ui/Pagination.vue";
import PageSizeSelectList from "@/shared/components/ui/PageSizeSelectList.vue";
import { formatCurrency } from "@/shared/currency.js";
import ContributionsNavigation from "@/employer/components/profile/ContributionsNavigation.vue";
import Widget from "@/shared/components/Widget.vue";
import Pill from "@/shared/components/ui/Pill.vue";
import { useUserStore } from "@/shared/store/user";
import { useThemeStore } from "@/shared/store/theme";
import { useContributionUploadedFileStore } from "@/employer/store/contributionUploadedFile";

@Component({
  components: {
    Button,
    ActionMenu,
    Pagination,
    PageSizeSelectList,
    ContributionsNavigation,
    Widget,
    Pill
  }
})
export default class PendingContributionsReport extends Vue {
  formatCurrency = formatCurrency;

  userStore = useUserStore();
  contributionFileStore = useContributionUploadedFileStore();
  themeStore = useThemeStore();

  @Prop()
  page: number;

  @Prop()
  routeToPendingContributionsList: (page: number) => Location;

  @Prop({ required: false })
  hideHeader: boolean;

  selectedItem = null;
  showConfirmCancelModel = false;
  isSubmitDisabled = true;
  contributionHoldDictionary = {};
  selectedHoldCount = 0;
  displayExpiredContributionsOnly = false;

  resetTransactionsDictionary (): void {
    this.contributionHoldDictionary = {};
    this.selectedItem = null;
    this.selectedHoldCount = 0;
    this.isSubmitDisabled = true;
  }

  changePendingContributionsInavtiveFilter (): void {
    this.displayExpiredContributionsOnly = !this.displayExpiredContributionsOnly;
    this.loadPendingContributions(true);
  }

  mounted () {
    this.loadPendingContributions(false);
  }

  switchPageSize () {
    this.$router.push(this.routeToPendingContributionsList(1));
    this.loadPendingContributions(true);
  }

  @Watch("page")
  onRouteValuePageNumberChanged () {
    this.loadPendingContributions(false);
  }

  setSelectedItem (employeeId: string): void {
    this.selectedItem = employeeId;
  }

  switchPage (toPage) {
    this.$router.push(this.routeToPendingContributionsList(toPage));
  }

  loadPendingContributions (clearState: boolean) {
    if (clearState) {
      this.contributionFileStore.clearPendingContributions();
    }

    this.contributionFileStore.fetchPendingContributions({
      id: this.userStore.employerId,
      pageNumber: this.page,
      displayExpiredOnly: this.displayExpiredContributionsOnly
    } as any);
  }

  hasSinglePendingRecord (pendingContributions: PendingContribution[]) {
    return pendingContributions === undefined || pendingContributions.length <= 1;
  }

  dateFormated (date) {
    return moment(date).format("MM/DD/YYYY");
  }

  downloadReport (displayExpiredContributionsOnly: boolean) {
    this.contributionFileStore.processPendingContributionsReport({
      employerId: this.userStore.employerId,
      displayExpiredContributionsOnly
    });
  }

  onClose (): void {
    this.showConfirmCancelModel = false;
  }

  onSubmit (): void {
    const contributionHoldIds = _.toArray(this.contributionHoldDictionary);
    this
      .contributionFileStore.cancelContributionHolds(
        { employerId: this.userStore.employerId, ids: contributionHoldIds as any })
      .then(x => {
        this.showConfirmCancelModel = false;
        this.resetTransactionsDictionary();
      });
  }

  isSelected (contributionHoldId: string): boolean {
    return _.has(this.contributionHoldDictionary, contributionHoldId);
  }

  updatecontributionHoldDictionary (contributionHoldId: string): void {
    if (this.contributionHoldDictionary[contributionHoldId]) {
      _.unset(this.contributionHoldDictionary, contributionHoldId);
    } else {
      this.contributionHoldDictionary[contributionHoldId] = contributionHoldId;
    }

    this.selectedHoldCount = _.size(this.contributionHoldDictionary);
    this.isSubmitDisabled = _.isEmpty(this.contributionHoldDictionary);
  }

  get pendingContributions () {
    return this.contributionFileStore.getPendingContributions;
  }

  saveSelections (): void {
    this.showConfirmCancelModel = true;
  }

  getContributionStatusCopy (pendingContribution: PendingContribution): string {
    return pendingContribution.isExpired ? "Expired" : "Pending";
  }

  getContributionStatusPillType (pendingContribution: PendingContribution): string {
    return pendingContribution.isExpired ? "error-pill" : "neutral-pill";
  }
}
